export const visit = (vm, at) => {
vm(require("timezone-utils/lang/da.lyaml"));
vm(require("ui-addon-i18n/lang/da.lyaml"));
vm(require("UIComponents/lang/da.lyaml"));
vm(require("MeetingsLib/lang/da.lyaml"));
vm(require("sanitize-text/lang/da.lyaml"));
vm(require("I18n/lang/da.lyaml"));
at({ "da": { "placeholderString": "M\xF8der" } });
};